import { render, staticRenderFns } from "./Profile-Legal.vue?vue&type=template&id=bf9995f2&scoped=true&"
import script from "./Profile-Legal.vue?vue&type=script&lang=js&"
export * from "./Profile-Legal.vue?vue&type=script&lang=js&"
import style0 from "./Profile-Legal.vue?vue&type=style&index=0&id=bf9995f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9995f2",
  null
  
)

export default component.exports